module.exports = __webpack_public_path__ + "static/media/BoxPlotQ8_4.acc8f2ce.svg";